import React from 'react';
import { Grid, IconButton, Tooltip } from '@mui/material';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SectionCard from '../ui/SectionCard';
import FieldDisplay from '../ui/FieldDisplay';
import { formatValue } from '../../utils/format';

// มูลค่างาน/เลขที่ PO กรอกตอน "จบงาน" (WON) เท่านั้น (ดู FinishJobDialog) แยกการ์ด
// ออกจากข้อมูลทั่วไปเพราะเป็นข้อมูลผลการปิดงาน ไม่ใช่ข้อมูลตอนสร้างโครงการ
export function JobResultCard({ opportunity, onEdit }) {
  return (
    <SectionCard
      icon={<WorkspacePremiumOutlinedIcon />}
      title="ผลการปิดงาน"
      accentColor="success.main"
      action={(
        <Tooltip title="แก้ไขมูลค่างาน/เลขที่ PO">
          <IconButton size="small" onClick={onEdit}>
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    >
      <Grid container spacing={2.5}>
        <Grid item xs={6}><FieldDisplay label="มูลค่างาน" value={formatValue(opportunity.value)} emphasis /></Grid>
        <Grid item xs={6}><FieldDisplay label="เลขที่ PO" value={opportunity.po_number} emphasis /></Grid>
      </Grid>
    </SectionCard>
  );
}

export default JobResultCard;
